import { Button, Grid, Typography } from "@mui/material"
import BannerIndication from "../../../../../../assets/img/banner indication.png"
import { BiLogoWhatsapp } from "react-icons/bi"
import useAuth from "../../../../../../context/auth"

export const Share = () => {
    const { user, handleIndicationTab } = useAuth()

    const shareWhatsApp = () => {
        const link = window.location.origin + "/comofunciona?c=" + user?.uuid
        window.open(`https://wa.me/?text=${link}`, '_blank')
    }

    return (
        <Grid
            display={"flex"}
            direction={"column"}
            alignItems={"center"}
            gap={"2rem"}
            width={"100%"}
            height={"100%"}
        >
            <img
                src={BannerIndication} alt="banner indicação"
                style={{
                    width: "100%"
                }}
            />

            <Typography
                fontSize={"2.4rem"}
                fontFamily={"Nexa ExtraLight"}
                fontWeight={100}
                textAlign={"center"}
                p={0}
                lineHeight={"3rem"}
            >
                <span
                    style={{
                        fontSize: "2.8rem",
                        fontFamily: "Nexa Heavy",
                        fontWeight: 900,
                        background: "linear-gradient(90deg, #1D22E6 0%, #00ECFF 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                    }}>Indicando Gyroo</span> para seus amigos empreendedores <span
                        style={{
                            fontSize: "2.8rem",
                            fontFamily: "Nexa Heavy",
                            fontWeight: 900,
                            background: "linear-gradient(90deg, #1D22E6 0%, #00ECFF 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}>você ganha R$ 20</span> para cada contrato aprovado
            </Typography>

            <Button
                startIcon={<BiLogoWhatsapp color="white" size={24} />}
                variant="contained"
                sx={{
                    background: "linear-gradient(90deg, #1D22E6 0%, #178BF1 100%)",
                    height: "4.8rem",
                    fontSize: "1.6rem",
                    fontWeight: 600,
                    animation: "pulse 2s infinite"
                }}
                onClick={shareWhatsApp}
            >
                Clique aqui e indique agora
            </Button>

            <Button
                variant="outlined"
                sx={{
                    borderRadius: "10px",
                    height: "4rem"
                }}
                onClick={() => {
                    handleIndicationTab("rewards")
                }}
            >
                Ver os ganhos
            </Button>

            {/* <LineComponent expansive={false} margin="0px" />

            <Typography
                fontWeight={600}
                fontSize={"1.6rem"}
                textAlign={"center"}
            >
                Baixe o material publicitário abaixo para enviar junto ao link de indicação.
            </Typography>

            <Button
                startIcon={<MdOutlineFileDownload size={18} />}
                variant="outlined"
                sx={{
                    borderRadius: "10px",
                    height: "4rem",
                    border: "none",
                    backgroundColor: "#FFFFFF",
                    fontSize: "14px",
                    fontWeight: 500
                }}
            >
                vídeo_01.mp4
            </Button>

            <Button
                startIcon={<MdOutlineFileDownload size={18} />}
                variant="outlined"
                sx={{
                    borderRadius: "10px",
                    height: "4rem",
                    border: "none",
                    backgroundColor: "#FFFFFF",
                    fontSize: "14px",
                    fontWeight: 500,
                    mt: "-1rem"
                }}
            >
                vídeo_02.mp4
            </Button>

            <Button
                startIcon={<MdOutlineFileDownload size={18} />}
                variant="outlined"
                sx={{
                    borderRadius: "10px",
                    height: "4rem",
                    border: "none",
                    backgroundColor: "#FFFFFF",
                    fontSize: "14px",
                    fontWeight: 500,
                    mt: "-1rem"
                }}
            >
                vídeo_03.mp4
            </Button> */}
        </Grid>
    )
}